import { html } from 'lit';
import { Users } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-users')
export class PdsIconUsers extends PdsIcon {
  @state()
  icon = Users;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
